import React, { useEffect, useState } from 'react'


function PaymentNow() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div className='mt-[80px]'>
                <div className='pt-[50px] md:px-[110px] px-[20px]'>
                    <div className="grid md:grid-cols-2 grid-cols-1 md:pb-[100px] pb-[30px] md:gap-[62px] gap-[30px] justify-center">
                        <div className='max-w-[603px] w-full mx-auto'>
                            <img src="/assets/about/img5.png" alt="" />
                            <div className='pt-[18px] flex flex-wrap gap-[18px]'>
                                <img src="/assets/about/img6.png" alt="" />
                                <img src="/assets/about/img7.png" alt="" />
                                <img src="/assets/about/img8.png" alt="" />
                                <img src="/assets/about/img9.png" alt="" />
                            </div>
                        </div>
                        <div className='max-w-[555px] w-full mx-auto'>
                            <h6 className="font-[700] font-manrope lg:text-[40px] text-[24px] pb-[5px] text-[#333333]">Help childen for orphanage scholarship in Newzealand</h6>
                            <div className='bg-[#FFEFE6] mt-[28px] p-[12px] rounded-[8px] mb-[12px] flex gap-[8px]'>
                                <img src="/assets/nav/alert-circle.svg" alt="" />
                                <div>
                                    <h6 className="font-[600] font-manrope text-[13px] text-[#0D0D12]">Information</h6>
                                    <p className="font-[400] font-manrope text-[13px] text-[#666D80]">Transaction only via application!</p>
                                </div>
                            </div>
                            <div className='bg-[#F6F8FA] border border-[#DFE1E7] rounded-[16px] p-[12px] items-center grid grid-cols-2 gap-[12px]'>
                                <select name="" id="" className='border-none bg-transparent font-[700] font-manrope text-[16px] text-[#333333] focus:outline-none py-[7px] px-[4px]'>
                                    <option value="">IDR</option>
                                </select>
                                <p className="text-right font-[700] text-[16px] text-[#333333] pr-[4px]">0</p>
                            </div>
                            <p className="pt-[8px] pb-[30px] font-[400] font-manrope text-[14px] text-[#666666]">The minimum donation is IDR15.000</p>
                            <div className="border border-[#DFE1E7] rounded-[16px] bg-[#FFFFFF] p-[12px]">
                                <h6 className="font-[600] font-manrope text-[20px] text-[#2B2B2B] pb-[12px]">Payment method</h6>
                                <div className='flex justify-between items-center'>
                                    <div className="flex gap-[8px] items-center">
                                        <img src="/assets/nav/bca.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[16px] text-[#2B2B2B]">BCA Virtual Account</p>
                                    </div>
                                    <button className='bg-[#FFFFFF] border border-[#DFE1E7] rounded-[6px] px-[16px] py-[8.5px] font-[600] font-manrope text-[11px] text-center text-[#0D0D12]'>Change</button>
                                </div>
                            </div>
                            <div className='pt-[24px] pb-[20px]'>
                                <h6 className="font-[500] font-manrope text-[20px] text-[#2B2B2B] pb-[5px]">Kiki Ariana</h6>
                                <p className="font-[400] font-manrope text-[16px] text-[#666666]">kikiariana@gmail.com</p>
                            </div>
                            <div className="flex justify-between items-center pb-[50px]">
                                <p className="font-[400] font-manrope text-[13px] text-[#666666]">Hide your name as anonim</p>
                                <input type="checkbox" />
                            </div>
                            <p className="font-[400] text-[16px] font-manrope text-[#0D0D12] pb-[8px]">Write your wish and encouragement</p>
                            <textarea rows="4" name="" id="" className='bg-[#FFFFFF] border border-[#DFE1E7] rounded-[10px] w-full py-[10px] px-[12px] font-[500] text-[14px] font-manrope text-[#0D0D12]'></textarea>
                            <p className="pt-[8px] font-manrope text-[16px] text-[#818898] pb-[40px]">Optional text</p>
                            <button onClick={() => setIsModalOpen(true)} className='d-btn w-full text-center'>DONATE NOW</button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    )
}

export default PaymentNow


function Modal({ isOpen, onClose }) {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[150] flex items-center justify-center bg-black bg-opacity-50"
            onClick={onClose}
        >
            <div
                className="lg:max-w-[583px] max-w-[90%] w-full mx-auto rounded-[30px] bg-[#FFFFFF] p-[38px]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex flex-col items-center">
                    <img src="/assets/nav/item1.svg" className='pt-[10px] lg:pb-[36px] pb-[20px]' alt="" />
                    <h6 className="font-[600] font-manrope text-[24px] text-center text-[#36394A]">Thank you for your kindness</h6>
                    <p className="max-w-[328px] w-full font-manrope text-[13px] text-[#4D4D4D] text-center pb-[12px]">Your support & good prayers mean a lot to us, i hope you are always healthy an have good fortune</p>
                    <h6 className="font-[600] font-manrope text-[24px] text-center text-[#FF6000] lg:pb-[44px] pb-[20px]">You gained +200 points</h6>
                </div>
                <div className="flex gap-[20px] flex-col">
                    <button className='border border-[#FF6000] rounded-[8px] py-[14.5px] text-center font-[700] font-manrope text-[18px] text-[#FF6000]'>VIEW YOUR DONATION</button>
                    <button className='d-btn w-full text-center'>BACK TO HOME</button>
                </div>
            </div>
        </div>
    );
}
